const SHOP_FOCUS_INTENT_KEY = 'shop:focus-intent';

export const SHOP_FOCUS_RESULTS = 'results';
export const SHOP_FOCUS_FILTER_BAR = 'filter-bar';

export function isShopPath(pathname = '') {
  return pathname === '/shop';
}

export function setShopFocusIntent(target) {
  if (typeof window === 'undefined' || !target) {
    return;
  }

  try {
    window.sessionStorage.setItem(SHOP_FOCUS_INTENT_KEY, String(target));
  } catch {
    // Ignore storage access failures in restricted environments.
  }
}

export function consumeShopFocusIntent() {
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    const value = window.sessionStorage.getItem(SHOP_FOCUS_INTENT_KEY) || '';
    window.sessionStorage.removeItem(SHOP_FOCUS_INTENT_KEY);
    return value;
  } catch {
    return '';
  }
}
